import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Create Batch", -1)
const _hoisted_2 = { class: "d-flex gap-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = ["srcdoc"]
const _hoisted_9 = { style: {"flex":"auto"} }

import { ref } from "vue";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import "jodit/build/jodit.min.css";
import { JoditEditor } from "jodit-vue";
import TopicService from "../../services/TopicService";
import notification from "@/core/plugins/notification";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateBatch',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(false);
const drawerRef = ref(false);
const languageList = ref<any>(["en-us", "zh-cn"]);
const receiverEmails = ref<any>("");
const formData = ref({
  topicId: 10003,
  topicKey: null,
  overwrite: true,
  siteId: null,
  receiverEmails: {},
  contents: {
    "en-us": {
      title: "",
      subTitle: "",
      content: "",
      language: "en-us",
    },
    "zh-cn": {
      title: "",
      subTitle: "",
      content: "",
      language: "zh-cn",
    },
  },
});


const onLanguageListChange = (langCode) => {
  if (languageList.value.includes(langCode)) {
    formData.value.contents[langCode] = {
      title: "",
      subTitle: "",
      content: "",
      language: langCode,
    };
  } else {
    delete formData.value.contents[langCode];
  }
};

const refreshHtml = (item) => {
  return item.content;
};

const submit = async () => {
  isLoading.value = true;
  try {
    var unTrimmedEmailList = receiverEmails.value.split(",");
    var trimmedEmailList = unTrimmedEmailList
      .map((email) => email.trim())
      .filter((email) => email !== "");
    formData.value.receiverEmails = trimmedEmailList;
    console.log(formData.value);
    await TopicService.createEmailBatch(formData.value);
    drawerRef.value = false;
    emits("eventSubmit");
    reset();
    notification.success();
  } catch (error) {
    console.error(error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const reset = () => {
  receiverEmails.value = "";
  languageList.value = ["en-us", "zh-cn"];
  formData.value = {
    topicId: 10003,
    overwrite: true,
    receiverEmails: {},
    contents: {
      "en-us": {
        title: "",
        subTitle: "",
        content: "",
      },
      "zh-cn": {
        title: "",
        subTitle: "",
        content: "",
      },
    },
  };
};

const show = (_data: any) => {
  drawerRef.value = true;
  if (_data) {
    formData.value = _data;
    receiverEmails.value = _data.receiverEmails.join(",");
    languageList.value = Object.keys(_data.contents);
  }
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawerRef.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((drawerRef).value = $event)),
    direction: "rtl",
    size: "90%"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        model: formData.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, { label: "Topic ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.topicId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.topicId) = $event)),
                  class: "w-125px",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Topic Key" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.topicKey,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.topicKey) = $event)),
                  class: "w-250px",
                  placeholder: "If send same email, use same key",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Email Receivers" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: isLoading.value,
                  class: "w-500px",
                  modelValue: receiverEmails.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((receiverEmails).value = $event)),
                  autosize: { minRows: 2, maxRows: 4 },
                  type: "textarea",
                  placeholder: "Enter email addresses separated by comma"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Select Site" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.siteId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.siteId) = $event)),
                  disabled: isLoading.value,
                  class: "w-250px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _hoisted_3,
          _createVNode(_component_el_form_item, { label: "Select Languages" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: languageList.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((languageList).value = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (content, index) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: index,
                      label: content.code,
                      value: content.code,
                      disabled: isLoading.value,
                      onChange: ($event: any) => (onLanguageListChange(content.code))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(content.code), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value", "disabled", "onChange"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tabs, { type: "card" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.contents, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: index,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_form_item, { label: "Title" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: item.title,
                              "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                              disabled: isLoading.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_form_item, { label: "Subtitle" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: item.subTitle,
                              "onUpdate:modelValue": ($event: any) => ((item.subTitle) = $event),
                              disabled: isLoading.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_form_item, { label: "Content" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_unref(JoditEditor), {
                                modelValue: item.content,
                                "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                                disabled: isLoading.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("iframe", {
                          srcdoc: refreshHtml(item),
                          width: "100%",
                          height: "100%"
                        }, null, 8, _hoisted_8)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (drawerRef.value = false)),
          type: "warning",
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: submit,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})